export const userData = {
  name: "Andreas Christoforou",
  gender: "male",
  birthday: "20.06.1970",
  birthtime: "08:20",
  birthplace: "Nicosia, Cyprus",
};
